import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const linkQnsToMissionAction = createAsyncThunk(
    'link-qns-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/link-qns-mission`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const linkQnsToMissionSlice = createSlice({
    name: 'link-qns-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(linkQnsToMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(linkQnsToMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(linkQnsToMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const linkQnsToMissionReducer = linkQnsToMissionSlice.reducer    